// English translations
import common from './en/common.json'
import errors from './en/errors.json'
import siteSettings from './en/site-settings.json'
import checkIn from './en/check-in.json'
import barcodeScan from './en/barcode-scan.json'
import checkout from './en/checkout.json'
import button from './en/button.json'
import fields from './en/fields.json'
import admin from './en/admin.json'
import core from './en/core.json'
import lib from './en/lib.json'
import brands from './en/brands.json'
import integrations from './en/integrations.json'

// French translations
import commonFr from './fr/common.json'
import adminFr from './fr/admin.json'

import alerts from './en/alerts.json'
import alertsAr from './ar/alerts.json'
import alertsEs from './es/alerts.json'
import alertsFr from './fr/alerts.json'

// Arabic translations
import commonAr from './ar/common.json'
import adminAr from './ar/admin.json'

// Spanish translations
import commonEs from './es/common.json'
import errorsEs from './es/errors.json'
import siteSettingsEs from './es/site-settings.json'
import checkInEs from './es/check-in.json'
import barcodeScanEs from './es/barcode-scan.json'
import checkoutEs from './es/checkout.json'
import buttonEs from './es/button.json'
import fieldsEs from './es/fields.json'
import adminEs from './es/admin.json'
import coreEs from './es/core.json'
import libEs from './es/lib.json'
import brandsEs from './es/brands.json'

export default {
  en: {
    common,
    errors,
    siteSettings,
    checkIn,
    barcodeScan,
    checkout,
    button,
    fields,
    admin,
    core,
    lib,
    brands,
    integrations,
    alerts,
  },
  fr: {
    common: commonFr,
    admin: adminFr,
    core,
    // Fallback to English for missing namespaces
    errors,
    siteSettings,
    checkIn,
    barcodeScan,
    checkout,
    button,
    fields,
    lib,
    brands,
    integrations,
    alerts: alertsFr,
  },
  ar: {
    common: commonAr,
    admin: adminAr,
    core,
    // Fallback to English for missing namespaces
    errors,
    siteSettings,
    checkIn,
    barcodeScan,
    checkout,
    button,
    fields,
    lib,
    brands,
    integrations,
    alerts: alertsAr,
  },
  es: {
    common: commonEs,
    errors: errorsEs,
    siteSettings: siteSettingsEs,
    checkIn: checkInEs,
    barcodeScan: barcodeScanEs,
    checkout: checkoutEs,
    button: buttonEs,
    fields: fieldsEs,
    admin: adminEs,
    core: coreEs,
    lib: libEs,
    brands: brandsEs,
    integrations,
    alerts: alertsEs,
  },
}
